/** The calendar contract shared by overview SQL and browser presentation. */
export const LESSON_TIME_ZONE = "Europe/London";
export const LESSON_WEEK_START_DAY = 1; // JavaScript weekday: Monday.
const weekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
export const LESSON_WEEK_LABEL = `${weekdays[LESSON_WEEK_START_DAY]}–${weekdays[(LESSON_WEEK_START_DAY + 6) % 7]}`;

const londonDay = new Intl.DateTimeFormat("en-CA", {
  timeZone: LESSON_TIME_ZONE, year: "numeric", month: "2-digit", day: "2-digit",
});

export function lessonWeekKey(startsAt: string): string | null {
  const instant = new Date(startsAt);
  if (!Number.isFinite(instant.getTime())) return null;
  const parts = londonDay.formatToParts(instant);
  const part = (type: string) => Number(parts.find(value => value.type === type)?.value);
  const day = new Date(Date.UTC(part("year"), part("month") - 1, part("day")));
  day.setUTCDate(day.getUTCDate() - (day.getUTCDay() - LESSON_WEEK_START_DAY + 7) % 7);
  return day.toISOString().slice(0, 10);
}

/** Input is already scoped to upcoming, non-cancelled lessons by the server. */
export function upcomingLessonWeek<T extends { startsAt: string }>(lessons: readonly T[]): T[] {
  const sorted = lessons.filter(lesson => lessonWeekKey(lesson.startsAt) !== null)
    .slice().sort((a, b) => Date.parse(a.startsAt) - Date.parse(b.startsAt));
  const week = sorted[0] && lessonWeekKey(sorted[0].startsAt);
  return sorted.filter(lesson => lessonWeekKey(lesson.startsAt) === week);
}
